import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer>
      <div className="container footer-grid">
        <div className="meta">
          <div className="brand" style={{ marginBottom: 16 }}>
            <span className="brand-mark"><ShieldCheck size={14} strokeWidth={1.5} /></span>
            QXAI.SPACE
          </div>
          <div>A product of <b>Media Minds AI Group</b></div>
          <div style={{ marginTop: 6, color: "var(--fg-faint)" }}>QuantumX · 2026</div>
        </div>
        <div className="footer-links">
          <div>
            <h5>Product</h5>
            <a href="#guarantees">Guarantees</a>
            <a href="#architecture">Architecture</a>
            <a href="#how">How it works</a>
            <a href="#cta">Pricing</a>
          </div>
          <div>
            <h5>Ecosystem</h5>
            <a href="https://veraregistry.web.app" target="_blank" rel="noopener noreferrer">VERA Registry</a>
            <a href="https://vverify.ai" target="_blank" rel="noopener noreferrer">V-Verify</a>
            <a href="https://veragraph.ai" target="_blank" rel="noopener noreferrer">VeraGraph</a>
            <a href="https://feedsyncai.com" target="_blank" rel="noopener noreferrer">FeedSync AI</a>
          </div>
          <div>
            <h5>Resources</h5>
            <a href="#manifesto">Manifesto</a>
            <a href="#architecture">Architecture</a>
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
          </div>
          <div>
            <h5>Company</h5>
            <a href="https://mediamindai.com" target="_blank" rel="noopener noreferrer">Media Minds AI</a>
            <a href="mailto:hello@mediamindai.com">Contact</a>
            <a href="/signin">Sign in</a>
            <a href="/signup">Get started</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
